import * as React from "react";
const SvgQuestionAnswer = props => /*#__PURE__*/React.createElement("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M22 6h-3v9H6v3h12l4 4V6Zm-5 7V2H2v15l4-4h11Z",
  fill: "currentColor"
}));
export default SvgQuestionAnswer;